import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UserAsssetService {


  constructor(private http: HttpClient) { }
  
getUserAssetApiList = () => {
    return this.http.get(environment.walletApiUrl + 'api/admin/getUserAssetList')
  }

  getUserAssetApiListDoc = () => {
    return this.http.get(environment.walletApiUrl + 'api/admin/getUserAssetList', { responseType: 'text' as 'json' })
  }


}

